(function () {
    'use strict';

    angular.module('swif.fluid')
    .config(route)
    .controller('FluidConfigurationController', FluidConfigurationController)
    .controller('FluidCategoriesConfigurationController', FluidCategoriesConfigurationController)
    .controller('FluidStatisticCategoriesConfigurationController', FluidStatisticCategoriesConfigurationController)
    .controller('FluidStatisticsConfigurationController', FluidStatisticsConfigurationController)
    .controller('FluidStatisticController', FluidStatisticController);

    function route ($routeProvider) {
        'ngInject';
        $routeProvider.when('/fluid/configuration_view', {
            templateUrl: 'partials/fluid/configuration_view.html',
            controller: 'FluidConfigurationController',
            reloadOnSearch: false
        });
    }

    function FluidCategoriesConfigurationController($scope, swif) {
        'ngInject';

        swif.settings.page.title = "Fluids module configuration";

        swif.collections.createOrUpdate(
            'fluids_categories',
            'fluids_category',
            {}
        ).then(function (collection) {
            $scope.categories = collection;
        });

        $scope.callback = function (error, data) {
            $scope.categories.fasterCallback(data);
        };
    }

    function FluidStatisticCategoriesConfigurationController($scope, swif) {
        'ngInject';

        swif.collections.createOrUpdate(
            'fluids_statistic_categories',
            'fluids_statistic_category',
            {}
        ).then(function (collection) {
            $scope.statistic_categories = collection;
        });

        $scope.callback = function (error, data) {
            $scope.statistic_categories.fasterCallback(data);
        };
    }

    function FluidStatisticsConfigurationController($scope, swif) {
        'ngInject';

        swif.collections.createOrUpdate(
            'fluids_statistics',
            'fluids_statistic',
            {}
        ).then(function (collection) {
            $scope.statistics = collection;
        });

        $scope.callback = function (error, data) {
            $scope.statistics.fasterCallback(data);
        };
    }

    function FluidStatisticController($scope, swif) {
        console.log('init FluidStatisticController');

        /**
         * Watch for category changes and query for related category unit
         * Use a watcher here to handle initial data (onChange is not fired
         * on initial load by swif-widget-select-one)
         */
        $scope.$watch('model.category_id', function (category) {
            var params = {
                fields: ['unit']
            };

            if (category) {
                // Query for category unit
                swif.data.get('fluids_statistic_category', category[0], params).then(function (data) {
                    $scope.unit = data.unit;
                });
            } else {
                $scope.unit = '';
            }
        });
    }

    function FluidConfigurationController ($scope, $q, swif) {
        'ngInject';
        console.log('init FluidConfigurationController');
        $scope.loading = {items: {}};

        $scope.refresh = function () {
            swif.message.loading($scope.loading.items);
            var deferred = [];

            _.forEach([
                'fluids_categories',
                'fluids_statistics',
                'fluids_statistic_categories'
            ], function (name) {
                var collection = swif.collection.getCollection(name);
                if (collection) {
                    deferred.push(collection.getItems());
                }
            });

            $q.all(deferred, function () {
                swif.message.loading($scope.loading.items, 'ok');
            }, function () {
                swif.message.loading($scope.loading.items, 'ko');
            });
        };
    }
})();
